import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { extractErrorMessage } from "@/lib/api";
import { Trash2 } from "lucide-react";

const ROLE_LABEL = { admin: "Admin", judge: "Árbitro", operator: "Operadora de Evento" };
const ROLE_CHIP = { admin: "chip-admin", judge: "chip-judge", operator: "chip-success" };

export default function Users() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "judge" });
  const [error, setError] = useState("");

  const load = async () => {
    const { data } = await api.get("/users");
    // Backend já filtra atletas — dupla proteção aqui
    setUsers(data.filter((u) => ROLE_LABEL[u.role]));
  };

  useEffect(() => {
    load();
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/register", form);
      setForm({ name: "", email: "", password: "", role: "judge" });
      await load();
    } catch (e) {
      setError(extractErrorMessage(e));
    }
  };

  const del = async (id) => {
    if (!window.confirm("Excluir usuário?")) return;
    await api.delete(`/users/${id}`);
    await load();
  };

  return (
    <div>
      <div className="overline mb-2">Gestão</div>
      <h1 className="font-display text-5xl font-black tracking-tight mb-6">USUÁRIOS</h1>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div>
          <div className="card p-5">
            <div className="overline mb-3">Novo Usuário</div>
            <form onSubmit={submit} className="space-y-3">
              <input
                data-testid="user-name"
                className="input-field"
                placeholder="Nome"
                required
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
              />
              <input
                data-testid="user-email"
                type="email"
                className="input-field"
                placeholder="E-mail"
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
              <input
                data-testid="user-password"
                type="password"
                className="input-field"
                placeholder="Senha"
                required
                minLength={4}
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
              />
              <select
                data-testid="user-role"
                className="input-field"
                value={form.role}
                onChange={(e) => setForm({ ...form, role: e.target.value })}
              >
                <option value="judge">Árbitro</option>
                <option value="operator">Operadora de Evento</option>
                <option value="admin">Administrador</option>
              </select>
              {form.role === "operator" && (
                <div className="text-[11px] text-[var(--text-secondary)] border border-white/10 px-3 py-2" data-testid="operator-role-hint">
                  A operadora começa <b>sem campeonatos</b>. Libere os campeonatos em{" "}
                  <Link to="/operadoras" className="text-[#C9A84C] underline">Operadoras</Link> ou aguarde a solicitação dela.
                </div>
              )}
              {error && (
                <div className="text-sm text-[#C9A84C] border border-[#C9A84C]/30 bg-[#C9A84C]/10 px-3 py-2">
                  {error}
                </div>
              )}
              <button data-testid="user-submit" className="btn-primary w-full">
                Criar
              </button>
            </form>
          </div>
        </div>
        <div className="lg:col-span-2">
          <div className="card">
            <table className="table-dense">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>E-mail</th>
                  <th>Papel</th>
                  <th className="text-right pr-4">Ações</th>
                </tr>
              </thead>
              <tbody>
                {users.map((u) => (
                  <tr key={u.id} data-testid={`user-row-${u.id}`}>
                    <td>{u.name}</td>
                    <td>{u.email}</td>
                    <td>
                      <span className={`chip ${ROLE_CHIP[u.role] || "chip-judge"}`}>
                        {ROLE_LABEL[u.role] || u.role}
                      </span>
                    </td>
                    <td className="text-right pr-4">
                      <button className="btn-ghost" onClick={() => del(u.id)}>
                        <Trash2 size={14} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
